import { Component, Input, OnInit } from "@angular/core";
import { Breadcrumb } from "../../../../utils/types/core/models/breadcrumb";
import { Router } from "@angular/router";

@Component({
    selector: "shared-breadcrumb",
    templateUrl: "./breadcrumb.component.html",
    styleUrls: ["./breadcrumb.component.scss"],
})
export class BreadcrumbComponent implements OnInit {
    @Input() routes: Breadcrumb[] = [];

    constructor(private router: Router) {}

    ngOnInit(): void {}

    onNavClick(index: number) {
        const navigation = this.routes[index];

        this.router.navigate(
            [navigation.routerLink],
            navigation.navigationExtras
        );
    }
}
